import { Injectable, Injector, inject } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { ExternalToolUrlParams } from '@nx-customer-apps/shared/interfaces';
import { ExternalTool } from '@nx-customer-apps/shared/enums';
import { WindowService } from '@nx-customer-apps/shared/services';
import { ProjectAccessStore } from '../state/project-access/project-access.store';
import { ProjectsService } from './projects.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ExternalToolUrlService {
    private environment = inject(EnvironmentService);
    private windowService = inject(WindowService);
    private projectAccessStore = inject(ProjectAccessStore);
    private injector: Injector = inject(Injector);
    private router = inject(Router);

    public getExternalToolUrl(tool: ExternalTool, params: ExternalToolUrlParams, route: string = ''): string {
        const queryParams = this.buildQueryParams(params);
        const externalToolUrl = this.environment.getExternalUrl(tool);
        return `${externalToolUrl}${route}?${queryParams}`;
    }

    public redirectToExternalToolByProjectId(tool: ExternalTool, params: ExternalToolUrlParams, route: string = ''): void {
        // TODO: Temporary solution - redirect to internal room-by-room calculation page.
        // Once the Air2Air external tool page is ready, remove the internal navigation.
        if (tool === ExternalTool.Air2AirPlanner && params.projectId) {
            const projectsService = this.injector.get(ProjectsService);
            const roomByRoomLink = projectsService.getRoomByRoomCalculationLink(params.projectId);
            this.router.navigate([roomByRoomLink]);
            return;
        }
        // ########### The end of temporary solution ###########

        this.projectAccessStore.skipProjectUnlockBeforeUnload();
        const url = this.getExternalToolUrl(tool, params, route);
        setTimeout(() => {
            this.windowService.nativeWindow.location.href = url;
        });
    }

    private buildQueryParams(params: ExternalToolUrlParams): string {
        return Object.keys(params)
            .map((key: string) => `${key}=${params[key as keyof ExternalToolUrlParams]}`)
            .join('&');
    }
}
